import { Component, Input } from '@angular/core';
import { DemographicInfo } from 'src/app/people/models/demographicInfo';

@Component({
  selector: 'read-only-address',
  templateUrl: './read-only-address.component.html',
  styleUrls: ['./read-only-address.component.scss'],
  standalone: false
})
export class ReadOnlyAddressComponent {
  @Input()
  address: DemographicInfo;

  @Input()
  hideStatus: boolean = false;
}
